import { Box, Typography, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';
import CompanyLogo from 'components/CompanyLogo';
import { StyledLogoContainer } from './styled';

type FormInfoType = {
  title: string;
  description?: string;
  linkText?: string;
  linkURL?: string;
};

const FormHeader = ({
  title,
  description,
  linkText,
  linkURL,
}: FormInfoType) => {
  const theme = useTheme();

  return (
    <Box sx={{ alignSelf: 'flex-start', py: theme.spacing(4) }}>
      <StyledLogoContainer>
        <CompanyLogo />
      </StyledLogoContainer>
      <Typography variant="h4" component="h1" mb={1} sx={{ fontSize: 24 }}>
        {title}
      </Typography>
      {description && (
        <Typography variant="body1" sx={{ color: theme.palette.grey[400] }}>
          {description}
          {linkURL && linkText && (
            <Typography
              variant="body1"
              component={Link}
              to={linkURL}
              sx={{
                fontSize: 'inherit',
                color: 'inherit',
                textDecoration: 'underline',
                ml: theme.spacing(0.5),
                cursor: 'pointer',
                ':hover': {
                  color: theme.palette.primary.main,
                  textDecorationColor: 'inherit',
                },
              }}
            >
              {linkText}
            </Typography>
          )}
        </Typography>
      )}
    </Box>
  );
};

export default FormHeader;
